import styled from 'styled-components';
import PageHeader from '@/components/pageHeader/PageHeader';
import { useValidatePaymentSelectState } from '@/features/paymentSelect/useValidatePaymentSelectState';
import { useValidateUserDetailsState } from '@/features/userDetails/useValidateUserDetailsState';
import { useSelectedProvider } from '@/features/paymentSelect/useSelectedProvider';
import StripeCard from '@/providers/stripe/StripeCard';
import BraintreeCard from '@/providers/braintree/BraintreeCard';
import RouteProps from '@/types/shared-types';
import { useAppSelector } from '@/store/hooks';
import { getPageHeaderInitialText, getPageHeaderSupplementaryText } from '@/utils/paymentTextUtils';
import RecaptchaContainer from '@/services/recaptcha/RecaptchaContainer';
import { usePaymentStuckDetection } from '@/hooks/usePaymentStuckDetection';

import { useValidateTransactionPending } from './useValidateTransactionPending';

const FormWrapper = styled.div`
  margin-top: 2.3rem;
`;

function PaymentForm({ totalSteps, currencySymbol, providerGroup }: RouteProps) {
  // Validate state is as expected, otherwise redirect to index or a previous step
  useValidateTransactionPending();
  useValidatePaymentSelectState(true);
  useValidateUserDetailsState();

  // Monitor for users getting stuck loading the payment form
  usePaymentStuckDetection();

  const { isSelectedProvider } = useSelectedProvider();
  const payinState = useAppSelector(state => state.payin);
  const isPayIn = !!payinState?.audience;

  const renderProviderCard = () => {
    if (isSelectedProvider('STRIPE')) {
      return <StripeCard currencySymbol={currencySymbol} />;
    }
    if (isSelectedProvider('BRAINTREE')) {
      return <BraintreeCard currencySymbol={currencySymbol} />;
    }
    return null;
  };

  return (
    <RecaptchaContainer>
      <PageHeader
        currentStep={4}
        totalSteps={totalSteps}
        headerText="Your payment details"
        initialText={getPageHeaderInitialText({ isPayIn, providerGroup  })}
        supplementaryText={getPageHeaderSupplementaryText({ isPayIn, payinState })}
        currencySymbol={currencySymbol}
      />
      <FormWrapper>{renderProviderCard()}</FormWrapper>
    </RecaptchaContainer>
  );
}

export default PaymentForm;
